import React from 'react';

import { ApplicationUnblockSearch } from '../../components/ApplicationsUnblock/ApplicationUnblockSearch';
import {
  GridCountFunction,
  GridGetterFunction,
} from '../../../common/components/Grid/GridDataTypes';
import { usePokCore } from '../../../common/hooks/usePokCore';
import { useTranslation } from '../../../common/hooks/useTranslation';

interface PendingApplicationUnblockTabProps {
  refresh?: boolean;
  onRowClick?: (key: string) => void;
}

export const PendingApplicationUnblockTab: React.FC<
  PendingApplicationUnblockTabProps
> = props => {
  const pok = usePokCore();
  const { t } = useTranslation('applicationLng');

  const getData = ((
    pageSize,
    pageNumber,
    orderBy,
    orderDirection,
    filterText,
  ) =>
    pok.applicationsUnblock.getAllPendingByPortion(
      t,
      pageSize,
      pageNumber,
      orderBy,
      orderDirection,
      filterText,
    )) as GridGetterFunction;

  const getCount = (filterText =>
    pok.applicationsUnblock.getAllPendingCount(
      filterText,
    )) as GridCountFunction;

  return (
    <ApplicationUnblockSearch
      getData={getData}
      getCount={getCount}
      isNavView
      showFilter
      {...props}
    />
  );
};
